export enum ItemType {
    Component = 0,
    Treatment = 1
}